import User from './user';

export default class AuthenticationService {
  static msal: Msal;

  static login(): void {
    if (this.nonAuthenticated()) {
      this.msal.signIn();
    }
  }

  static logout(): void {
    if (this.isAuthenticated()) {
      this.msal.signOut();
    }
  }

  static isAuthenticated(): boolean {
    return this.msal.isAuthenticated();
  }

  static nonAuthenticated(): boolean {
    return !this.isAuthenticated();
  }

  static userLoggedIn(): User {
    if (this.isAuthenticated()) {
      return User.of(this.msal.data.user);
    }
    return User.ofEmpty();
  }

  static token(attempts = 3, delayMs = 300): Promise<string> {
    return this.msal.acquireToken().then((token: any) => {
      if (token && token.accessToken) {
        return token.accessToken;
      }
      if (attempts <= 1) {
        return Promise.reject(new Error('Não foi possível obter o token de autenticação.'));
      }
      return new Promise<string>((resolve, reject) => {
        setTimeout(() => {
          this.token(attempts - 1, delayMs).then(resolve, reject);
        }, delayMs);
      });
    });
  }

  static photo(): Promise<any> {
    return this.msal
      .msGraph([{ url: '/me' }, { url: '/me/photo/$value', responseType: 'blob' }]);
  }
}

interface Msal {
  data: any;
  isAuthenticated(): boolean;
  signIn(): any;
  signOut(): any;
  acquireToken(): Promise<string>;
  msGraph(endpoins: any[]): Promise<any>;
}
